/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Suggestion_3Inputs */

const en_us2_search_suggestion_3 = /** @type {(inputs: Search_Suggestion_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knee pain`)
};

const pt_br2_search_suggestion_3 = /** @type {(inputs: Search_Suggestion_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dor no joelho`)
};

const es_419_search_suggestion_3 = /** @type {(inputs: Search_Suggestion_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolor de rodilla`)
};

const pt_pt2_search_suggestion_3 = /** @type {(inputs: Search_Suggestion_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dor no joelho`)
};

const fr_fr2_search_suggestion_3 = /** @type {(inputs: Search_Suggestion_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Douleur au genou`)
};

const de_de2_search_suggestion_3 = /** @type {(inputs: Search_Suggestion_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knieschmerzen`)
};

const it_it2_search_suggestion_3 = /** @type {(inputs: Search_Suggestion_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolore al ginocchio`)
};

/**
* | output |
* | --- |
* | "Knee pain" |
*
* @param {Search_Suggestion_3Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_suggestion_3 = /** @type {((inputs?: Search_Suggestion_3Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Suggestion_3Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_suggestion_3(inputs)
	if (locale === "es-419") return es_419_search_suggestion_3(inputs)
	if (locale === "pt-PT") return pt_pt2_search_suggestion_3(inputs)
	if (locale === "fr-FR") return fr_fr2_search_suggestion_3(inputs)
	if (locale === "de-DE") return de_de2_search_suggestion_3(inputs)
	if (locale === "it-IT") return it_it2_search_suggestion_3(inputs)
	return en_us2_search_suggestion_3(inputs)
});
export { search_suggestion_3 as "search.suggestion_3" }